import { render, staticRenderFns } from "./DashboardReportingModal.vue?vue&type=template&id=871be04c&scoped=true&"
import script from "./DashboardReportingModal.vue?vue&type=script&lang=js&"
export * from "./DashboardReportingModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReportingModal.vue?vue&type=style&index=0&id=871be04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871be04c",
  null
  
)

/* custom blocks */
import block0 from "./DashboardReportingModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports